// import { stringify } from 'qs'
import axios from 'axios'
import { createRequest } from '@/utils/request'

const request = createRequest({})

export async function getPositionPUN({ lng, lat }: any) {
  return request.post('/nddt/portal/server/api/httpForward/lx_uav_api', {
    url: `${window.SystemConfig.rightNavCtrlConfig.dataApiUrl8765}/services/lxpf/address/coord?serviceKey=tmiKPqf1niMu5rq1VcG49XKIYmhwDJEh&lat=${lat}&lng=${lng}`,
  })
}

export async function getWMSPosPUN(data: any) {
  // return request.post('/server/api/httpForward/lx_uav_api', {
  //   data: {
  //     url:
  //     window.SystemConfig.rightNavCtrlConfig.geoserverBaseOWSUrl + '?service=WFS&version=1.0.0&request=GetFeature&typeName=' +
  //       encodeURI(
  //         'lx:' +
  //           data.name +
  //           '&maxFeatures=50&outputFormat=application/json&cql_filter=INTERSECTS(the_geom,POINT(' +
  //           data.pos.lng +
  //           ' ' +
  //           data.pos.lat +
  //           '))',
  //       ),
  //   },
  // });
  return request.get(`${window.SystemConfig.rightNavCtrlConfig.geoserverBaseOWSUrl}?service=WFS
  &version=1.0.0&request=GetFeature&typeName=lx:${data.name}&maxFeatures=50
  &outputFormat=application/json&cql_filter=INTERSECTS(the_geom,POINT(${data.pos.lng} ${data.pos.lat}))`)
}

export async function handleDownload(params: any) {
  const formData = new FormData()
  formData.append('file', params.files)
  formData.append('width', params.width)
  formData.append('height', params.height)
  return axios.post('/nddt/portal/server/api/ko-uav-model/editPicture', formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  })
}

export async function queryaddress({ lat, lng }: any) {
  return request.get(
    `/nddt/portal/lxApi/services/lxpf/address/coord?serviceKey=&byPass=false&lat=${lat}&lng=${lng}`,
  )
}

export async function IGetPlotData() {
  const obj = {
    serviceKey: 'gPhBTyE8X3/njCv6gtQxsmgvR6FTS8L3sXPJInCldcS5Vqu2jJstizdt4UmdqkPFbvmVBb5lXDjL9lOfgmCSyQ==',
    crs: 'EPSG:5174',
    bbox: '217365,447511,217636,447701',
    width: 915,
    height: 700,
    format: 'image/png',
  }
  return request.get(
    `/1611000/nsdi/LandUseService/wms/getLandUseWMS?serviceKey=${obj.serviceKey}&crs=${obj.crs}&bbox=${obj.bbox}&width=${obj.width}&height=${obj.height}&format=${obj.format}`,
  )
}

export async function IGetPopulation(obj: any) {
  return request.get(
    `/nddt/portal/nongdi-data-api/ndpf/portal/api/fclt/getPopulationInfo.do?apiKey=${obj.apiKey}&sggCd=${obj.sggCd}&sessionId=${obj.sessionId}`,
  )
}

export async function IGetBusiness(obj: any) {
  return request.get(
    `/nddt/portal/nongdi-data-api/ndpf/portal/api/fclt/getBusinessInfo.do?apiKey=${obj.apiKey}&sidoCd=${obj.sidoCd}&sessionId=${obj.sessionId}`,
  )
}

export async function IGetSessionId() {
  return request.get(
    '/nddt/portal/nongdi-data-api/ndpf/portal/api/menu/ajaxLogin.do?apiKey=test&userId=nddt',
  )
}

export async function IGetHeaderData(params: any) {
  let getUrl = '/nddt/portal/nongdi-data-api/ndpf/portal/api/menu/getHeaderList.do?'
  Object.entries(params).forEach(([key, value]) => {
    getUrl += `${key}=${value}&`
  })
  if (getUrl.endsWith('&')) {
    getUrl = getUrl.slice(0, -1)
  }
  return request.get(getUrl)
}

export async function IGetSubHeaderData(params: any) {
  let getUrl = '/nddt/portal/nongdi-data-api/ndpf/portal/api/menu/getUserAllList.do?'
  Object.entries(params).forEach(([key, value]) => {
    getUrl += `${key}=${value}&`
  })
  if (getUrl.endsWith('&')) {
    getUrl = getUrl.slice(0, -1)
  }
  return request.get(getUrl)
}

export async function IGetSupportData(params: any) {
  let getUrl = '/nddt/portal/nongdi-data-api/ndpf/portal/api/fclt/getLocgovSprtPolicyList.do?'
  Object.entries(params).forEach(([key, value]) => {
    getUrl += `${key}=${value}&`
  })
  if (getUrl.endsWith('&')) {
    getUrl = getUrl.slice(0, -1)
  }
  return request.get(getUrl)
}

export async function IGetFcltDetail(params: any) {
  let getUrl = '/nddt/portal/nongdi-data-api/ndpf/portal/api/fclt/getFcltDetail.do?'
  Object.entries(params).forEach(([key, value]) => {
    getUrl += `${key}=${value}&`
  })
  if (getUrl.endsWith('&')) {
    getUrl = getUrl.slice(0, -1)
  }
  return request.get(getUrl)
}

export async function IGetQnaList(params: any) {
  let getUrl = '/nddt/portal/nongdi-data-api/ndpf/portal/api/fclt/getQnaList.do?'
  Object.entries(params).forEach(([key, value]) => {
    getUrl += `${key}=${value}&`
  })
  if (getUrl.endsWith('&')) {
    getUrl = getUrl.slice(0, -1)
  }
  return request.get(getUrl)
}

// 13
export async function IInsertQna(params: any) {
  let getUrl = '/nddt/portal/nongdi-data-api/ndpf/portal/api/fclt/insertQna.do?'
  Object.entries(params).forEach(([key, value]) => {
    getUrl += `${key}=${value}&`
  })
  if (getUrl.endsWith('&')) {
    getUrl = getUrl.slice(0, -1)
  }
  return request.post(getUrl)
}

// 14
export async function IUpdateQna(params: any) {
  let getUrl = '/nddt/portal/nongdi-data-api/ndpf/portal/api/fclt/updateQna.do?'
  Object.entries(params).forEach(([key, value]) => {
    getUrl += `${key}=${value}&`
  })
  if (getUrl.endsWith('&')) {
    getUrl = getUrl.slice(0, -1)
  }
  return request.post(getUrl)
}

// 15
export async function IDeleteQna(params: any) {
  let getUrl = '/nddt/portal/nongdi-data-api/ndpf/portal/api/fclt/deleteQna.do?'
  Object.entries(params).forEach(([key, value]) => {
    getUrl += `${key}=${value}&`
  })
  if (getUrl.endsWith('&')) {
    getUrl = getUrl.slice(0, -1)
  }
  return request.post(getUrl)
}

// 16
export async function IInsertAnswer(params: any) {
  let getUrl = '/nddt/portal/nongdi-data-api/ndpf/portal/api/fclt/insertAnswer.do?'
  Object.entries(params).forEach(([key, value]) => {
    getUrl += `${key}=${value}&`
  })
  if (getUrl.endsWith('&')) {
    getUrl = getUrl.slice(0, -1)
  }
  return request.post(getUrl)
}

// 17
export async function IUpdateAnswer(params: any) {
  let getUrl = '/nddt/portal/nongdi-data-api/ndpf/portal/api/fclt/updateAnswer.do?'
  Object.entries(params).forEach(([key, value]) => {
    getUrl += `${key}=${value}&`
  })
  if (getUrl.endsWith('&')) {
    getUrl = getUrl.slice(0, -1)
  }
  return request.post(getUrl)
}

export async function IAjaxLogin() {
  let getUrl = '/nddt/portal/nongdi-data-api/ndpf/portal/api/menu/ajaxLogin.do?'
  const params = {
    apiKey: 'test',
    userId: 'nddt',
  }
  Object.entries(params).forEach(([key, value]) => {
    getUrl += `${key}=${value}&`
  })
  if (getUrl.endsWith('&')) {
    getUrl = getUrl.slice(0, -1)
  }
  return request.get(getUrl)
}

export async function querySpatial() {
  const layerName = ' lx:nd-road2, lx:nd-road3'
  const point = '127.1374681314 35.374553385'
  const bufferRadius = 500
  const params = new URLSearchParams({
    service: 'WFS',
    version: '2.0.0',
    request: 'GetFeature',
    typeName: layerName,
    outputFormat: 'application/json',
    cql_filter: `DWITHIN(the_geom, POINT(${point}), ${bufferRadius}, meters)`,
    SRSName: 'EPSG:4326',
  })
  return request(`${window.SystemConfig.rightNavCtrlConfig.geoserverWfsUrl}?${params.toString()}`)
}

/**
 * 전북지역 지적도 기준으로 검색하려는 원에 해당하는 정보 가져오기
 * @param circle 검색하려는 구역
 * @returns
 */
export async function queryIntersects(circle: any) {
  let strPolygon = ''
  circle.geometry.coordinates.forEach((item2: any, index2: number) => {
    item2.forEach((element: any, index3: number) => {
      const pointArr = element.flat(3)
      const strPoint = `${pointArr[0]} ${pointArr[1]},`
      strPolygon += strPoint
    })
  })
  strPolygon = strPolygon.substring(0, strPolygon.length - 1)

  let ndroad = ''
  for (let i = 0; i < 14; i++) {
    ndroad += `lx:nd-road${i + 1},`
  }
  ndroad = ndroad.substring(0, ndroad.length - 1)

  const layerName = ndroad
  const params = new URLSearchParams({
    service: 'WFS',
    version: '1.0.0',
    request: 'GetFeature',
    typeName: layerName,
    outputFormat: 'application/json',
    cql_filter: `INTERSECTS(the_geom,POLYGON((${strPolygon})))`,
    SRSName: 'EPSG:4326',
  })

  return request(`${window.SystemConfig.rightNavCtrlConfig.geoserverWfsUrl}?${params.toString()}`)
}

export async function IUpdateFcltLike(params: any) {
  let getUrl = '/nddt/portal/nongdi-data-api/ndpf/portal/api/fclt/updateFcltLike.do?'
  Object.entries(params).forEach(([key, value]) => {
    getUrl += `${key}=${value}&`
  })
  if (getUrl.endsWith('&')) {
    getUrl = getUrl.slice(0, -1)
  }
  return request.get(getUrl)
}

export async function IGetLoginUser(params: any) {
  let getUrl = '/nddt/portal/nongdi-data-api/ndpf/portal/api/user/getLoginUser.do?'
  Object.entries(params).forEach(([key, value]) => {
    getUrl += `${key}=${value}&`
  })
  if (getUrl.endsWith('&')) {
    getUrl = getUrl.slice(0, -1)
  }
  return request.get(getUrl)
}

export async function IUpdateMenuLike(params: any) {
  let getUrl = '/nddt/portal/nongdi-data-api/ndpf/portal/api/menu/updateMenuLike.do?'
  Object.entries(params).forEach(([key, value]) => {
    getUrl += `${key}=${value}&`
  })
  if (getUrl.endsWith('&')) {
    getUrl = getUrl.slice(0, -1)
  }
  return request.get(getUrl)
}
